import _, { isArray } from 'lodash';
import { CommitDishes, Condiment, CourseDetail, MenuDish } from '../../constants/type.constant';
import { StateManager } from '../../redux/stateManager';
import { getCacheField } from '../../tools/get-cache-field';
import { getSettingInfo } from '../../tools/get-setting-info';
import { WebsocketClient } from '../../websocket/module';
import { Cart2 } from './type'
import { get } from 'lodash';
import Store from '../../redux/store';
import i18n from '../../i18n';
import { DefaultRequest } from '../../requests/default.request';

// 服务端购物车
export class SeverShoppingCartModule {
    // $ Meta Data
    // 购物车数据源
    public metaData: Cart2.Cart | undefined = undefined;
    // $ Rules Switches
    // 全局自助点餐规则
    public GLOBAL_SELF_ORDER_RULE: boolean = true;
    // 全局轮次开关
    public GLOBAL_LIMIT: boolean = true;
    // 过敏原 & 菜品其他标识过滤器
    public allergensAndIngredentsFilter: { [key: string]: string[] } = {};
    // 是否已进入下一轮(轮次倒计时中)
    public isToNextTurn: boolean = true;
    // 是否禁用手动推进轮次
    public disableToNext: boolean = false;
    // 更新购物车的参数
    public cartParam: any = {};
    // 更新购物车-兼容报错的参数
    public errorKeys: string[] = [];

    // *********************
    // Rule Checker Functions
    // *********************

    /**
     * 更新模组数据
     * @param data
     * @param setCach 是否更新当前轮次
     */
    public updateSeverShoppingCartModule(data: Cart2.Cart | undefined, setCach?: boolean) {
        this.metaData = data;
        // 更新当前轮次
        if (setCach) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'advGlobalRound',
                value: data?.r3?.nowTurn || 1
            })
        }

        // todo 是否需要存缓存
        // Store.dispatch({
        //     type: 'SET_CACHING',
        //     path: 'serverShoppingCart',
        //     value: data
        // })
    }


    /**
     * 连接购物车
     * - 先初始化购物车
     * - 选择user,再使用该方法
     * @param prosp
     */
    public connetSeverShoppingCart(props: { cartFind: Cart2.CartFind, user?: { userId?: string, userName?: string, userType?: number }; }) {
        const { cartFind, user } = props
        console.log({
            cartFind: {
                // orderId: `${getCacheField('orderTab.orderId')}`,
                orderId: ``,
                tableId: `${getCacheField('tableId')}`,
                ...cartFind
            },
            user,
            project: 'QOP_COP'
        });
        WebsocketClient.connectServerCart({
            cartFind: {
                // orderId: `${getCacheField('orderTab.orderId')}`,
                orderId: ``,
                tableId: `${getCacheField('tableId')}`,
                ...cartFind
            },
            user,
            project: 'QOP_COP'
        });
    }


    /**
     * 更新购物车
     * - 数量、备注、调味品
     * @param dish
     */
    public updateServerCart(
        props: {
            dish: MenuDish | Cart2.Item,
            /**
             * - type 0 修改数量 1 修改非数量字段
             * - state 0 菜单 1 购物车
             * - notSelf true 0 菜单.在购物车加入别人点菜品
             * - nonQuantity true 修改调味品或备注
             */
            action?: { type: number, state: number, notSelf?: boolean, nonQuantity?: boolean },
            // 0 加 1 减
            mathSymbol?: number,
            // 值
            mathValue?: number,
            // todo
            // expandDish?: MenuDish | Cart2.Item
            // 首次超额后的添加
            isAddedToCart?: boolean,
        }
    ) {
        let TABLE_MAX_NUM;
        let isSelectRuleLnrMaxNum = true;
        const WS_CONNECT_STATUS = StateManager.getFromCache('WS_CONNECT_STATUS');
        if (!navigator.onLine || !WS_CONNECT_STATUS) {
            // MESSENGER
            WebsocketClient.emit("MESSENGER", {
                message: i18n.t('general_text_poor_network'),
                level: 'Warning',
            })
            return
        }
        const { dish, action, mathSymbol, mathValue, isAddedToCart } = props;
        this.cartParam = _.cloneDeep(props);
        if (this.metaData) {
            let customer = getCacheField('orderTab.customer');
            let person = getCacheField('orderTab.person');
            let user = _.find(this.metaData.users, (n) => n.userName === customer);
            let cacheData = StateManager.getFromCache(['advGlobalRound']);
            // 获取点餐模式
            const autonomous = getSettingInfo('rule-autonomous-meal', 'value');
            // 调味品
            let dishCondiments: any = [];
            if (dish.condiments && dish.condiments.length > 0) {
                dishCondiments = (dish.condiments as Condiment[] || []).map((v: any) => {
                    // 备注和调味品  空格替换'_'
                    let regex = /\s+/gi;
                    let name = v.name ?? v.item_name1
                    return {
                        originId: v.originId || `${v.item_id}`,
                        // inOrderId:''
                        name: name.replace(regex, '_'),
                        price: Number(v.price ?? v.price_1 ?? v.actual_price),
                        remark: '',
                    }
                })
            }
            // 区分菜单或购物车菜品
            let FixedDish;
            // 菜品
            let menuItem: any;
            // 购物车菜品id
            let itemTargetFind;
            // 菜品类型
            let dishType;
            // 备注
            let remark;
            // post course DATA
            let postCourseData: Cart2.SetMealGroup[] = [];
            // 菜品沽清规则参数
            let dishBargainRuleParams: Cart2.DishBargainRule = {}
            // 在菜单添加
            if (action?.state === 0) {
                FixedDish = dish as MenuDish;
                TABLE_MAX_NUM = FixedDish.rule_table_max_num as any;
                const ORIGIN_RULE_LNR_MAX_NUM = FixedDish.rule_lnr_max_num;
                isSelectRuleLnrMaxNum = (ORIGIN_RULE_LNR_MAX_NUM * person) < (TABLE_MAX_NUM || 0);
                const MAX_NUM = [void 0 , null].includes(TABLE_MAX_NUM) ? ORIGIN_RULE_LNR_MAX_NUM : ((ORIGIN_RULE_LNR_MAX_NUM * person) < TABLE_MAX_NUM ? ORIGIN_RULE_LNR_MAX_NUM : TABLE_MAX_NUM);
                dishType = FixedDish.item_type === 3 ? 1 : 0;
                remark = FixedDish.remarks;
                dishBargainRuleParams = {
                    bargain_stype: FixedDish.bargain_stype,
                    bargain_item_id: FixedDish.bargain_item_id,
                    bargain_num_cur: FixedDish.bargain_num_cur,
                }
                // 菜品详情
                menuItem = {
                    // 菜品源的id
                    originId: `${FixedDish?.item_id}`,
                    // 二级菜单id
                    secondMenuId: `${FixedDish.dmi_slu_id}`,
                    // 菜品名称
                    name: FixedDish.item_name1,
                    name2: FixedDish.item_name2 || '',
                    // 类型 0 菜品 1服务
                    type: 0,
                    // 菜品类型 0 菜品 1套餐
                    dishType: dishType,
                    // 菜品原单价
                    originPrice: FixedDish.price_1,
                    // 菜品现单价
                    price: FixedDish.price_1,
                    // 轮次
                    turn: parseInt(cacheData['advGlobalRound'] || 1),
                    // 调味品
                    condiments: dishCondiments,
                    // 账号源id
                    userId: user?.userId,
                    //  账号源名称
                    userName: user?.userName,
                    // // todo 账号类型  0 STAFF 1 CUSTOMER 2 RESTAURANT
                    userType: 1,
                    // 来源项目
                    project: 'QOP_COP' as Cart2.Project.QOP_COP,
                    //  菜品规则
                    r1: {
                        // 是否开启R1规则
                        r1Enabled: FixedDish.rule_lnr_enable === 1,
                        // R1规则限定数量
                        r1ExcessedNum: MAX_NUM,
                        // 是否允许超额
                        r1IsAllowExcessed: FixedDish.rule_lnr_limit_enable === 1,
                        // 超额后的价格
                        r1ExcessedPrice: FixedDish.rule_lnr_limit_price,
                    },
                    // 轮次规则： 0 开启 1禁用(全局限制优先)
                    r3Enable: this.GLOBAL_LIMIT === false ? false : FixedDish.not_joining_global_limit === 0,
                    // 同类菜品限制规则
                    r8: {
                        // 是否开启R8规则
                        r8Enabled: true,
                        // R8规则限定数量
                        r8ExcessedNum: FixedDish.category_order_limit
                    },
                    // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
                    printClass: FixedDish.print_class === null ? -1 : FixedDish.print_class,
                    // 打印机设备
                    printDevice: FixedDish.print_device || [],
                    // 菜品规格
                    unit: FixedDish.unit_1 || '',
                    // 折扣分项器
                    discountItemizer: Number(FixedDish.discount_itemizer),
                    // 套餐详情
                    setMealGroups: [],
                    // 可选调味品组
                    selectCondimentGroup: FixedDish?.required_condiment || -1,
                }
                // 菜品是套餐处理
                if (FixedDish.item_type === 3) {
                    // 拷贝当前 menuItem
                    const curMenuItem = _.cloneDeep(menuItem);
                    // 处理后的套餐打印信息
                    let setMealGroup: Cart2.SetMealGroup[] = [];
                    let param: Cart2.SetMealGroup = {
                        originId: "",
                        name: "",
                        items: [],
                        isRequired: false,
                        chooseNum: 0
                    };
                    // 套餐区域
                    (FixedDish.containsDishes || []).forEach(itemGroup => {
                        let dishs: Cart2.SetMealItem[] = [];
                        let SetMealItem: Cart2.SetMealItem = {
                            originId: "",
                            name: "",
                            name2: "",
                            type: 0,
                            dishType: 0,
                            extraPrice: 0,
                            totalNum: 0,
                            condiments: [],
                            // // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
                            printClass: 0,
                            // // 打印机设备
                            printDevice: [],
                            // 套餐菜品ID
                            orderDetailId: 0,
                        };
                        (itemGroup.course_detail || []).forEach((item: CourseDetail) => {
                            if ((item.num || 0) > 0) {
                                SetMealItem = {
                                    // 菜品源id
                                    originId: item.menu_item_id?.toString() || '',
                                    // 订单菜品id
                                    inOrderId: item.menu_item_id?.toString(),
                                    // 菜品名称
                                    name: item.item_name1 || '',
                                    name2: item.item_name2 || '',
                                    // 类型
                                    type: 0,
                                    // 菜品类型
                                    dishType: 0,
                                    // 套餐菜品额外价格
                                    extraPrice: item.price || 0,
                                    // 总数量
                                    totalNum: item.num || 0,
                                    // 调味品
                                    condiments: [],
                                    // 备注
                                    remark: '',
                                    // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
                                    printClass: item?.print_class || 0,
                                    // 打印机设备
                                    printDevice: item?.print_device || [],
                                    // 套餐菜品ID
                                    orderDetailId: item?.detail_id || 0,
                                };
                                if (!(menuItem?.print_device || []).length) {
                                    // $ 套餐菜品是否存在打印组
                                    if ((item.print_device || []).length) {
                                        const subItemPrintDevice = item.print_device || [];
                                        const isSetPrintClass = subItemPrintDevice.some(print => print.print_device_id !== -1);
                                        if (isSetPrintClass) {
                                            menuItem.printDevice = subItemPrintDevice.reduce<any>((_p, _c) => {
                                                _p.push({
                                                    ..._c,
                                                    interface: `tcp://${_c.printer_name}:9100`,
                                                    order_head_id: this.metaData?.orderId,
                                                    original_project: 'QOP',
                                                    // item.project,
                                                    remark: "",
                                                    table_name: this.metaData?.tableId,
                                                    type: curMenuItem.type,
                                                    item_name1: curMenuItem.name,
                                                    item_name2: curMenuItem.name2,
                                                    customer_number: this.metaData?.orderCustomerNum || 1,
                                                });
                                                return _p;
                                            }, []);
                                            menuItem.printClass = item.print_class || -1;

                                            // 如果套餐本身没有打印组，赋值处理后的打印组信息
                                            // _.set(menuItem, 'printDevice', menuItem.printDevice);

                                        }
                                    }
                                }
                                dishs.push(SetMealItem);
                            }
                        });

                        param = {
                            // 套餐组对象id
                            originId: itemGroup.course_group_id?.toString() || '',
                            // 套餐组名称
                            name: itemGroup.course_group_name || '',
                            // 是否必选
                            isRequired: itemGroup.is_must === 1,
                            // 选择的数量
                            chooseNum: itemGroup.choose_num || 0,
                            items: dishs
                        };
                        setMealGroup.push(param);

                    })
                    _.set(menuItem, 'setMealGroups', setMealGroup)
                }
                itemTargetFind = {
                    itemFind: {
                        originId: `${FixedDish.item_id}`,
                    }
                }
            }
            // 在购物车操作菜品
            else {
                FixedDish = dish as Cart2.Item;
                dishType = FixedDish.dishType;
                remark = FixedDish.remark;
                const {r1TableMaxNum , isSelectRuleLnrMaxNum: isSelectedRuleLnrMaxNum, ...r1Rest } = (FixedDish as Cart2.Item)?.r1 as Cart2.R1Config ;
                TABLE_MAX_NUM = r1TableMaxNum;
                isSelectRuleLnrMaxNum = !!isSelectedRuleLnrMaxNum;
                // 套餐菜品套餐组
                const couresArr: any[] = (FixedDish as Cart2.Item).setMealGroups as any;
                if (!_.isEmpty(couresArr)) {
                    if (couresArr[0].course_detail) {
                        couresArr?.forEach(comboGroup => {
                            let dishes: Cart2.SetMealItem[] = [];
                            (comboGroup.course_detail || []).forEach((item: CourseDetail, index: number) => {
                                let setMealItem = {
                                    // 菜品源id
                                    originId: `${item.menu_item_id || ''}`,
                                    // 订单菜品id
                                    inOrderId: `${item.menu_item_id || ''}`,
                                    // 菜名1
                                    name: item.item_name1 || '',
                                    // 菜名2
                                    name2: item.item_name2 || '',
                                    // 类型
                                    type: 0,
                                    // 菜品类型
                                    dishType: 0,
                                    // 套餐菜品额外价格
                                    extraPrice: item.price ?? 0,
                                    // 总数量
                                    totalNum: item.num || 0,
                                    // 调味品
                                    condiments: [],
                                    // 备注
                                    remark: '',
                                    // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
                                    printClass: item?.print_class || 0,
                                    // 打印机设备
                                    printDevice: typeof item.print_device === 'string' ? JSON.parse(item.print_device || '[]') : item.print_device || [],
                                    // 套餐菜品ID
                                    orderDetailId: item?.detail_id || 0,
                                    index: index
                                };
                                dishes.push(setMealItem);
                            })

                            const params = {
                                // 套餐组对象id
                                originId: `${comboGroup.course_group_id || ''}`,
                                // 套餐组名称
                                name: comboGroup.course_group_name || '',
                                // 是否必选
                                isRequired: comboGroup.is_must === 1,
                                // 最大选择数量
                                chooseNum: comboGroup.choose_num || 0,
                                // 套餐组菜品
                                items: dishes,
                            };
                            postCourseData.push(params)
                        })
                    } else {
                        postCourseData = FixedDish.setMealGroups as Cart2.SetMealGroup[]
                    }
                }

                itemTargetFind = {
                    itemFind: {
                        id: `${FixedDish.id}`,
                        originId: `${FixedDish.originId}`,
                        // inOrderId: '',
                    }
                }
                dishBargainRuleParams = {
                    bargain_stype: FixedDish.bargain_stype,
                    bargain_item_id: FixedDish.bargain_item_id,
                    bargain_num_cur: FixedDish.bargain_num_cur,
                }
                // 区分点击他人\自己的菜品

                menuItem = {
                    // 菜品源的id
                    originId: FixedDish?.originId,
                    // 二级菜单id
                    secondMenuId: `${FixedDish.secondMenuId}`,
                    // 菜品名称
                    name: FixedDish.name,
                    // 菜品名称
                    name2: FixedDish.name2 || '',
                    // 类型 0 菜品 1服务
                    type: 0,
                    // 菜品类型 0 菜品 1套餐
                    dishType: FixedDish.dishType,
                    // 菜品原单价
                    originPrice: FixedDish.originPrice,
                    // 菜品现单价
                    price: FixedDish.price,
                    // 轮次
                    turn: parseInt(cacheData['advGlobalRound'] || 1),
                    // 调味品
                    condiments: dishCondiments,
                    // 账号源id
                    userId: user?.userId,
                    //  账号源名称
                    userName: user?.userName,
                    // // todo 账号类型  0 STAFF 1 CUSTOMER 2 RESTAURANT
                    userType: 1,
                    // 来源项目
                    project: 'QOP_COP' as Cart2.Project.QOP_COP,
                    //  菜品规则
                    r1: r1Rest,
                    // 轮次规则： 0 开启 1禁用
                    r3Enable: FixedDish.r3Enable,
                    // 同类菜品限制规则
                    r8: FixedDish.r8,
                    // 岗位（大厨，二厨，寿司，出菜口等等, Null/-1代表菜品无需打印或显示）
                    printClass: FixedDish.printClass,
                    // 打印机设备
                    printDevice: FixedDish.printDevice,
                    // 菜品规格
                    unit: FixedDish.unit,
                    // 折扣分项器
                    discountItemizer: Number(FixedDish.discountItemizer),
                    // 在购物车加入别人点菜品
                    remark,
                    // 套餐详情
                    setMealGroups: postCourseData || [],
                    // 可选调味品组
                    selectCondimentGroup: FixedDish?.selectCondimentGroup || -1,
                }
            };

            // 删除menuItem的报错字段
            if (this.errorKeys && this.errorKeys.includes('selectCondimentGroup')) {
                console.log('删除menuItem的报错字段--selectCondimentGroup');
                (Object.keys(menuItem) || []).includes('selectCondimentGroup') && delete menuItem['selectCondimentGroup'];
            }

            // 处理备注
            remark = remark ? remark.replace(/\s+/gi, '_') : '';
            // 提交数据
            let postdata: {
                cartFind?: Cart2.CartFind,
                itemTarget: Cart2.ItemTarget,
                action: Cart2.CartAction,
                marketingConfig: Cart2.MarketingConfig,
                compatibleRules?: Cart2.CompatibleRules,
                extraR1config?: Cart2.ExtraR1Config
            } = {
                itemTarget: {
                    find: action?.state === 0 ? undefined : itemTargetFind,
                    menuItem: menuItem as unknown as Cart2.Item
                },
                action: {
                    // - 0 修改数量 1 修改非数量字段
                    type: action?.type || 0,
                    // - 0 菜单 1 购物车
                    state: action?.notSelf === true ? 0 : (action?.state || 0),
                    updatedValue: {
                        quantity: action?.nonQuantity ? undefined : {
                            // 0 加 1 减
                            mathSymbol: mathSymbol || 0,
                            // 值
                            mathValue: mathValue || 1
                        },
                        // 修改调味品或备注
                        nonQuantity: { condiments: dishCondiments, remark, setMealGroups: postCourseData },
                    },
                    ruleConfig: {
                        // 菜品规则
                        r1: {
                            enable: true,
                            // id购物车菜品的id ; originId菜品的原id;  inOrderId 订单菜品id
                            // 在菜单添加只传源id即可
                            itemFind: { id: undefined, originId: itemTargetFind?.itemFind.originId },
                            domain: {
                                userId: user?.userId,
                                userName: user?.userName,
                                // 账号类型 0 STAFF 1 CUSTOMER 2 RESTAURANT
                                userType: 1,
                                project: 'QOP_COP' as Cart2.Project.QOP_COP,
                                // 0 菜品 1 服务
                                type: 0,
                                // // 0 菜品 1 套餐
                                // dishType
                            }
                        },
                        // 轮次规则
                        r3: {
                            // 全局轮次开关
                            enable: this.GLOBAL_LIMIT,
                            // id购物车菜品的id ; originId菜品的原id;  inOrderId 订单菜品id
                            // 在菜单添加只传源id即可
                            itemFind: {},
                            domain: {
                                userId: user?.userId,
                                userName: user?.userName,
                                // 账号类型 0 STAFF 1 CUSTOMER 2 RESTAURANT
                                userType: 1,
                                turn: parseInt(cacheData['advGlobalRound'] || 1),
                                project: 'QOP_COP' as Cart2.Project.QOP_COP,
                                // 0 菜品 1 服务
                                type: 0,
                                // // 0 菜品 1 套餐
                                // dishType
                            }
                        },
                        r8: {
                            // 是否校验
                            enable: true,
                            // 校验范围
                            itemFind: {},
                            // 校验范围
                            domain: {
                                userId: user?.userId,
                                userName: user?.userName,
                                //  账号类型  0 STAFF 1 CUSTOMER 2 RESTAURANT
                                userType: 1,
                                // turn: parseInt(cacheData['advGlobalRound'] || 1),
                                project: 'QOP_COP' as Cart2.Project.QOP_COP,
                                // 0 菜品 1 服务
                                type: 0,
                                // // 0 菜品 1 套餐
                                // dishType,
                                // 二级菜单id
                                secondMenuId: `${menuItem.secondMenuId}`
                            }
                        }
                    },
                    followingOpt: { 
                        mergeSameItem: true,  
                        firstExcessWarning: true
                    }
                },
                // 校验营销规则
                marketingConfig: {
                    // m1 点该菜的人数占总人数的比值大于等于minPercent时，则触发条件
                    m1: {
                        // 自主点餐模式 人数大于1 添加菜品 菜品数量由0变成1时 触发
                        enable: autonomous && person > 1 && autonomous.status && mathSymbol === 0 && get(dish, 'quantity') === 0,
                        itemFind: { id: itemTargetFind?.itemFind?.id, originId: itemTargetFind?.itemFind.originId },
                        domain: {
                            turn: parseInt(cacheData['advGlobalRound'] || 1),
                            project: 'QOP_COP' as Cart2.Project.QOP_COP,
                            // 0 菜品 1 服务
                            type: 0,
                            // 0 菜品 1 套餐
                            dishType
                        },
                        minPercent: 0.51
                    },
                    // 当每个顾客至少点了minItemNumPerUser个菜品时，若该菜品的总量占所有菜品总量的比值大于等于minPercent时，则触发条件
                    m2: {
                        // 添加菜品时候触发
                        enable: mathSymbol === 0,
                        itemFind: { id: itemTargetFind?.itemFind?.id, originId: itemTargetFind?.itemFind.originId },
                        domain: {
                            turn: parseInt(cacheData['advGlobalRound'] || 1),
                            project: 'QOP_COP' as Cart2.Project.QOP_COP,
                            // 0 菜品 1 服务
                            type: 0,
                            // 0 菜品 1 套餐
                            dishType
                        },
                        minPercent: 0.2,
                        minItemNumPerUser: 3
                    }
                },
                // 兼容规则
                compatibleRules: {
                    isAddedToCart: !!isAddedToCart,
                    dishBargainRule: dishBargainRuleParams
                },
                extraR1config: ![void 0, null].includes(TABLE_MAX_NUM) ? {
                    isSelectRuleLnrMaxNum,
                    r1TableMaxNum: TABLE_MAX_NUM,
                } : {} as Cart2.ExtraR1Config
            }
            // 删除postdata的报错字段
            if (this.errorKeys.length > 0) {
                ['compatibleRules', 'extraR1config'].forEach(key => {
                    if (this.errorKeys.includes(key)) {
                        console.log('删除postdata的报错字段', key);
                        // @ts-ignore
                        (Object.keys(postdata) || []).includes(key) && delete postdata[key];
                    }
                })
            }
            WebsocketClient.updateServerCart(postdata);
        }
    }

    /**
     * 提交购物车
     * @param props
     */
    public submitCart(props: {
        dishRules: CommitDishes['rule'],
        postData: Cart2.CommitDishesItem[],
        roundListDetail: {
            dishes: Cart2.Item[];
            totalNum: number;
            totalPrice: number;
            r3TotalNum: number;
            r3HistoryTotalNum: number;
            r3HistoryDishes: Cart2.Item[];
        } | undefined,
    }) {
        const { postData, roundListDetail } = props
        const WS_CONNECT_STATUS = StateManager.getFromCache('WS_CONNECT_STATUS');
        if (!navigator.onLine || !WS_CONNECT_STATUS) {
            // MESSENGER
            WebsocketClient.emit("MESSENGER", {
                message: i18n.t('general_text_poor_network'),
                level: 'Warning',
            })
            return
        }
        // 当前操作人userId userName
        // let customer = getCacheField('orderTab.customer');
        // let user = _.find(this?.metaData?.users, (n) => n.userName === customer) || { userId: '', userName: '' };
        // 查找qop打印设置索引
        let settingInfo = StateManager.getFromCache('settingInfo') || [];
        let index = settingInfo.findIndex((target: any) => target.id === 37);
        let printChecked = !!_.get(settingInfo, `${index}.value.enable`, false);
        // 购物车的菜品
        // let roundListDetail = this.getCurrentCustomerCart({});
        // let postData = this.buildPostDataServerShoppingCar(roundListDetail?.dishes || []);

        // 提交
        WebsocketClient.submitCart({
            itemsInfo: postData,
            orderInfo: {
                totalCount: roundListDetail?.totalNum || 0,
                isPrint: printChecked,
                printType: 'sendorder'
            },
            // 默认顾客名称id都是101
            user: {
                userId: '101',
                userName: '101',
                userType: 1
            }
        })
    }


    /**
     * 批量删除菜品
     * @param props
     */
    public emptyCartItem(props: { selectedDishesIds?: string[], all?: boolean }) {
        const WS_CONNECT_STATUS = StateManager.getFromCache('WS_CONNECT_STATUS');
        if (!navigator.onLine || !WS_CONNECT_STATUS) {
            // MESSENGER
            WebsocketClient.emit("MESSENGER", {
                message: i18n.t('general_text_poor_network'),
                level: 'Warning',
            })
            return
        }
        let res = this.getCurrentCustomerCart({});
        let dishes = res?.dishes;
        if (dishes && dishes.length) {
            if (!props.all && props.selectedDishesIds) {
                dishes = dishes.filter((n) => { return props?.selectedDishesIds?.includes(n.id) })
            }
            let itemsInfo: {
                id: string;
                ruleConfig: Cart2.RuleConfig;
            }[] = [];
            dishes?.forEach((v) => {
                let dish = this.getDishServerShoppingCar(v);
                itemsInfo.push({
                    id: dish.id,
                    ruleConfig: {
                        r1: dish.ruleConfig.r1,
                        r3: { enable: false, itemFind: {}, domain: {} }
                    }
                })
            })
            WebsocketClient.emptyCartItem({ itemsInfo });
        }
    }


    /**
     * 推进下一轮
     * @param props
     */
    public toNextTurn(props: {}) {
        // 将范围内的菜品推到下一轮。（默认所有菜品）
        let operation = {
            withItem: {
                itemFind: {},
                domain: {}
            }
        }
        WebsocketClient.toNextTurn({ operation });
    }

    /**
     * 获取当前轮次当前顾客的购物车菜品
     * - customer 指定顾客
     * - all 返回所有顾客
     */
    public getCurrentCustomerCart(props: { customer?: string, all?: boolean }) {
        let cacheData = StateManager.getFromCache(['advGlobalRound', 'orderTab.customer']);
        let currentCustom = cacheData['orderTab.customer'];
        // 购物车详情
        const items = this.metaData?.items;
        // 历史购物车
        const historyItems = this.metaData?.historyItems;
        if (items) {
            // 当前轮次
            const currentTurnItems = _.find(items, (n) => { return n.turn === cacheData.advGlobalRound }) || {};
            // 当前轮次 历史菜品
            const currentTurnHistoryItems = _.find(historyItems, (n) => { return n.turn === cacheData.advGlobalRound }) || {};
            // 当前顾客或所有人的购物车菜品
            const currentCustomsItems = _.find(currentTurnItems?.list, (n) => {
                if (props.all) {
                    return _.has(n, 'ALL');
                } else {
                    return n.userName === (props.customer ?? currentCustom);
                }
            });
            // 当前顾客或所有人的历史购物车菜品（当前轮次）
            const currentCustomsHistoryItems = _.find(currentTurnHistoryItems?.list, (n) => {
                if (props.all) {
                    return _.has(n, 'ALL');
                } else {
                    return n.userName === (props.customer ?? currentCustom);
                }
            });
            //  分析（数量、价格）
            const ANALYSIS_OBJECT = _.find(currentTurnItems?.list, (n) => {
                return _.has(n, 'ANALYSIS_OBJECT');
            });
            // 分析超额、调味品菜品
            let dishes = this.analyzeDish((props.all ? currentCustomsItems?.ALL : currentCustomsItems?.list) || []);
            let r3Dishes = _.cloneDeep(dishes).filter((item) => { return item.r3Enable });
            // 开启r3轮次规则的菜品总数
            let r3TotalNum = _.sumBy(r3Dishes, (item) => { return item.totalNum }) || 0;
            let totalNum = 0;
            let totalPrice = 0;

            // 返回historyItems中的当前轮次当前用户的菜品数
            let historydishes = this.analyzeDish((props.all ? currentCustomsHistoryItems?.ALL : currentCustomsHistoryItems?.list) || []);
            let r3HistoryDishes = _.cloneDeep(historydishes).filter((item) => { return item.r3Enable });
            // 开启r3轮次规则的历史菜品总数
            let r3HistoryTotalNum = _.sumBy(r3HistoryDishes, (item) => { return item.totalNum }) || 0;

            if (props.all) {
                (ANALYSIS_OBJECT?.ANALYSIS_OBJECT || []).forEach((n) => {
                    let keyName = Object.keys(n)[0];
                    totalNum += n[`${keyName}`].totalNum;
                    totalPrice += n[`${keyName}`].totalPrice;
                })
            } else {
                let currentCustomAnalysis = _.find(ANALYSIS_OBJECT?.ANALYSIS_OBJECT, (n) => { return _.has(n, (props.customer ?? currentCustom)) })
                totalNum = currentCustomAnalysis?.[(props.customer ?? currentCustom)].totalNum || 0;
                totalPrice = currentCustomAnalysis?.[(props.customer ?? currentCustom)].totalPrice || 0;
            }
            return {
                dishes,
                totalNum,
                totalPrice,
                r3TotalNum,
                r3HistoryTotalNum,
                r3HistoryDishes
            };
        }
    }


    /**
     * 分析菜品的调味品和超额价格
     */
    public analyzeDish(dishes: Cart2.Item[]) {
        if (dishes && isArray(dishes)) {
            dishes.forEach((dish) => {
                let condimentsTotalPrice = _.sumBy(dish.condiments, (n) => { return n.price }) * dish.totalNum;
                let excessPriceString = dish.excessedNum > 0 ? `Ext. ${dish?.r1?.r1ExcessedPrice.toFixed(2)} × ${dish.excessedNum}` : '';
                let condimentsPriceString = condimentsTotalPrice > 0 ? `Con. ${condimentsTotalPrice.toFixed(2)}` : '';
                dish.excessPriceAndCondimentsPriceForView = `${excessPriceString} ${condimentsPriceString}`.trim();
            })
            // 按照用户名排序
            dishes = dishes.sort((a, b) => {
                return Number(a.userName) - Number(b.userName)
            })
        }
        return dishes;
    }

    /**
     * 服务端购物车-构建提交数据
     */
    public buildPostDataServerShoppingCar(dishes: Cart2.Item[]): Cart2.CommitDishesItem[] {
        let newDishes: Cart2.CommitDishesItem[] = [];
        if (dishes) {
            let regex = /\s+/gi;
            dishes?.forEach((item) => {
                // 备注和调味品  空格替换'_'
                // 处理调味品
                let condiments = _.cloneDeep(item.condiments);
                condiments.forEach((val) => {
                    val.name = val.name.replace(regex, '_');
                });
                item.condiments = condiments;
                // 处理备注
                let dishRemarks = _.cloneDeep(item.remark);
                dishRemarks = dishRemarks ? dishRemarks.replace(regex, '_') : '';
                item.remark = dishRemarks;
                // 根据设置调用接口 isInterfaceSwitch 这个值一直为true
                if (getCacheField('isInterfaceSwitch')) {
                    newDishes.push(this.getDishServerShoppingCar(item));
                }
            })
        }
        return newDishes;
    }
    /**
     * 服务端购物车-处理菜品数据
     */
    public getDishServerShoppingCar(dish: Cart2.Item) {
        let cacheData = StateManager.getFromCache(['tableName', 'turnInfo', 'orderTab']);
        // 范围
        let domain = {
            userId: dish.userId,
            userName: dish?.userName,
            userType: 1,
            project: 'QOP_COP' as Cart2.Project.QOP_COP,
            // 0 菜品 1 服务
            type: 0,
            // 0 菜品 1 套餐
            dishType: dish.dishType
        }
        let newDish = {
            id: dish.id,
            eat_type: 0,
            is_discount: 0,
            is_make: 0,
            n_service_type: null,
            rush: 0,
            totalCount: dish.totalNum,
            check_name: cacheData['turnInfo']['check_name'],
            remark: cacheData['turnInfo']['remark'],
            //  注意: ruleConfig 与更新购物车方法updateServerCart ruleConfig 一至
            ruleConfig: {
                // 菜品规则
                r1: {
                    enable: true,
                    // id购物车菜品的id ; originId菜品的原id;  inOrderId 订单菜品id
                    itemFind: { id: undefined, originId: dish.originId },
                    domain
                },
                // 轮次规则
                r3: {
                    // 全局轮次开关
                    enable: this.GLOBAL_LIMIT,
                    // id购物车菜品的id ; originId菜品的原id;  inOrderId 订单菜品id
                    itemFind: {},
                    domain: {
                        ...domain,
                        turn: dish.turn,
                    }
                },
                r8: {
                    enable: !!dish.r8,
                    itemFind: {},
                    domain: {
                        ...domain,
                        secondMenuId: dish.secondMenuId
                    }
                }
            }
        };
        return newDish;
    }

    public toNextTurnManually(props: {}) {
        // 手动将范围内的菜品推到下一轮。（默认所有菜品）
        const operation = {
            withItem: {
                itemFind: {},
                domain: {}
            }
        }
        WebsocketClient.toNextTurnManually({ operation });
    }

    /**
     * 获取订单的轮次规则
     */
     public async getOrderTurn() {
        // 轮次规则
        let turnInfo = await DefaultRequest.getTurnInfo(
            getCacheField('orderTab.orderId'),
            Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9
        );

        Store.dispatch({
            type: 'SET_CACHING',
            path: 'turnInfo',
            value: turnInfo
        })
        
        return turnInfo
    }

    /**
     * 获取菜品过敏原 & 其他标识过滤器标识
     */
    public getAllergensAndIngredentsFilterFlag = (item: MenuDish): boolean => {
        // 过敏原 & 菜品标识过滤器标识
        let filterFlag: boolean = false;
        if (Object.keys(this.allergensAndIngredentsFilter).length) {
            Object.keys(this.allergensAndIngredentsFilter).forEach(key => {
                if (key === 'allergen') {
                    for (let i = 0; i < item.allergen.length; i++) {
                        if (this.allergensAndIngredentsFilter[key]?.includes(item.allergen[i])) {
                            filterFlag = true;
                            break;
                        }
                        else {
                            continue;
                        }
                    }
                }
                if (key === 'other_detail_info') {
                    for (let i = 0; i < item.other_detail_info.length; i++) {
                        if (this.allergensAndIngredentsFilter[key]?.includes(item.other_detail_info[i])) {
                            filterFlag = true;
                            break;
                        }
                        else {
                            continue;
                        }
                    }
                }
            })
        }
        return filterFlag;
    }
}